<audio #audioEl
       (ended)="handleEnded()"
       (loadedmetadata)="handleLoadedMetadata()"
       (pause)="handlePause()"
       (play)="handlePlay()"
       (timeupdate)="handleTimeUpdate()"
       [src]="src || null"></audio>

<button (click)="togglePlay()" [disabled]="disabled || !src" class="flex items-center">
  <img [src]="isPlaying ? '/assets/icons/feather/pause.svg' : '/assets/icons/feather/play.svg'" alt="Icon" class="h-[1.4rem]">
</button>
<span class="cd-text-b3 w-[8rem] truncate">{{ timeLabel }}</span>
<span (click)="seek($event)" class="w-full flex h-[0.5rem] bg-neutral-300 rounded cursor-pointer">
  <span [style.width.%]="progressPercent" class="flex h-[0.5rem] bg-neutral-600 rounded"></span>
</span>
<div class="relative flex items-center ml-auto">
  <button (click)="showVolume = !showVolume" [disabled]="disabled || !src" class="flex items-center">
    <img [src]="isMuted || volume === 0 ? '/assets/icons/feather/volume-x.svg' : '/assets/icons/feather/volume-2.svg'" alt="Icon" class="h-[1.4rem]">
  </button>
  @if (showVolume) {
    <div class="absolute right-0 top-8 bg-neutral border border-neutral-200 rounded-md shadow-e1 p-3 w-40 z-10">
      <div class="cd-text-b5 text-neutral-500 mt-2">Volumen</div>
      <input (input)="changeVolume($event)"
             [disabled]="disabled || !src"
             [value]="volume"
             aria-label="Volume"
             class="h-1 w-full accent-[var(--color-neutral-600)]"
             max="1"
             min="0"
             step="0.01"
             type="range"/>
    </div>
  }
</div>
<div class="relative flex items-center">
  <button (click)="showMenu = !showMenu" [disabled]="disabled" class="flex items-center">
    <img alt="Icon" class="h-[1.2rem]" src="/assets/icons/feather/more-vertical.svg">
  </button>
  @if (showMenu) {
    <div class="absolute right-0 top-8 bg-neutral border border-neutral-200 rounded-md shadow-e1 p-2 w-40 z-10">
      <button class="w-full text-left cd-text-b4 text-neutral-500 cursor-default" type="button">Opciones</button>
    </div>
  }
</div>
